var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstructions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "instructions-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.22 158.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "cls-1",
    d: "M20,158.45a19.35,19.35,0,0,1-14.21-5.83A19.35,19.35,0,0,1,0,138.41V20A19.35,19.35,0,0,1,5.83,5.83,19.35,19.35,0,0,1,20,0H80.72l47.5,47.5v90.92a19.92,19.92,0,0,1-20,20ZM70.38,57.84V20H20V138.42h88.14V57.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "cls-2",
    d: "M33.88,124.91H94.35V108.18H33.88Zm0-30.24H94.35V77.94H33.88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "var(--primary-color)",
    x: 33.11,
    y: 77.23,
    width: 62,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "var(--primary-color)",
    x: 33.11,
    y: 107.23,
    width: 62,
    height: 18
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructions);
export default __webpack_public_path__ + "static/media/instructions.c66070a0b0d2fad7f4d7f345c53a5984.svg";
export { ForwardRef as ReactComponent };